import { Component, OnInit, inject } from '@angular/core';
import { API_CONFIG } from 'app/api-config/api-config';
import { IApiConfig, IHeader } from 'app/interfaces';
import { HomeService } from 'app/modules/home/services/home.service';
import { FLU_CAMPAIGN_ID, COVID_CAMPAIGN_ID } from 'app/shared/constants/campaign-constants';

import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-assessments',
  templateUrl: './assessments.component.html',
  styleUrls: ['./assessments.component.scss'],
  standalone: true,
  imports: [RouterOutlet],
})
export class AssessmentsComponent implements OnInit {
  progressBarTitle: string = '';
  readonly FLU_CAMPAIGN_ID = FLU_CAMPAIGN_ID;
  readonly COVID_CAMPAIGN_ID = COVID_CAMPAIGN_ID;
  activeCampaign: string = '';
  assessmentId: number | null = null;
  fluHeader: IHeader | null = null;
  covidHeader: IHeader | null = null;
  selectedCapmaign: number = FLU_CAMPAIGN_ID;
  private apiConfig: IApiConfig = inject(API_CONFIG);
  private homeService: HomeService = inject(HomeService);
  constructor() {}

  ngOnInit() {
    this.fluHeader = this.homeService.fluHeader.value;
    this.covidHeader = this.homeService.covidHeader.value;
    this.selectedCapmaign = this.homeService.getActiveCampaign();
  }
}
